<script setup lang='ts'>
import { APP_ROUTER } from '@qctsw/common'
import { useGetRouteQuery } from '@/shared/function'
import { logicNewsColumn } from '@/logic/news/column'
import { NEWS_CLASS_SITE_META } from '@/shared/site'

const { changeMeta } = useSite(NEWS_CLASS_SITE_META)
const columnId = useGetRouteQuery('id', '')
const {
  state,
  columnData,
  getNewsColumnData,
} = logicNewsColumn()

function changeMetaHandler() {
  if (!columnData.value?.length)
    return
  const name = columnData.value.find(v => Number(v.id) === Number(columnId.value))?.columnSimpleName
  changeMeta({
    title: name ? `${name} - 汽车投诉网` : NEWS_CLASS_SITE_META.title,
    keywords: [name, ...NEWS_CLASS_SITE_META.keywords].filter(Boolean) as string[],
  })
}
useActivatedWatch(() => [
  watch(() => [columnId.value, columnData.value.length], changeMetaHandler, { immediate: true }),
])

await getNewsColumnData()
changeMetaHandler()
</script>

<template>
  <div h-14 w-full>
    <UtilLoadState :state="state" :reload-handler="getNewsColumnData">
      <div class="menu max-w-275">
        <div class="flex items-center h-8 w-full">
          <NuxtLink
            v-for="v, i in columnData"
            :key="i" :to="APP_ROUTER.newsClass({ id: v.id })"
            class="menu-item leading-8 text-slate-7 ml-7 first:ml-0 relative"
            :class="[(Number(columnId) === v.id || (!columnId && !i)) ? 'active' : '']"
          >
            {{ v.columnSimpleName }}
          </NuxtLink>
        </div>
      </div>
    </UtilLoadState>
  </div>
</template>

<style scoped lang="scss">
.menu {
  --uno: bg-white w-full h-14 flex items-center justify-center;
  --uno: z-99 overflow-auto fixed top-22;
}

.active-item {
  --uno: font-bold text-primary;
}

.active {
  font-weight: bold;
}

.active::after {
  content: "";
  width: 30px;
  height: 4px;
  background: #3b82f6;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}
</style>
